// extracted by mini-css-extract-plugin
export var numpadContainer = "_qp-1";
export var phoneButton = "_qp-0";